import React, {useState, useEffect}from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from 'react-native';
import styled from 'styled-components/native';
import {
    WorkoutsParent,
    WorkoutContainerText,
    WorkoutTextHeader,
    CerebrocoreCommonTextComponent,
    WorkoutContainerHeaderThree,
    WorkoutCommonButton
} from '../../styles/common-styles';

function PractitionerRow({navigation}) {

    const { current_workout } = useSelector((state) => state.cbcWorkout);
    const { userType, userId } = useSelector((state) => state.cbcAuthorization);
    const { activityChoices } = useSelector((state) => state.cbcActivities);

    const activityObj = [
        {
            activity_list: activityChoices,
            category_name: 'Free choice',
            category_text: 'Please select an activity from below.',
        },
    ];

    if (userType == 'Client') {
        return;
    }

    return (

        <PractitionerRowParent>
            <PractitonerRowHeader>
                Practitioner Tools
            </PractitonerRowHeader>

            <WorkoutContainerText>
                Use the buttons below to play any exercise for demo or testing purposes.
            </WorkoutContainerText>

            <PractionerRowTool
                onPress={() => {
                    navigation.navigate('activitylist', {
                        activityObj,
                        current_workout,
                        navigation,
                        isWorkout:false
                    });
                }}
            >
                <ButtonText>Exercises</ButtonText>
            </PractionerRowTool>
            <PractionerRowTool
                onPress={() => {
                    navigation.navigate('activitycontainer', {
                        activityName: "cbc-hrv",
                        activityId: "27",
                        userId: userId,
                        gameType: 1,
                        workoutId: 0
                    })
                }}>

                <ButtonText>Focused Breathing</ButtonText>
            </PractionerRowTool>
        </PractitionerRowParent>
    )
}

export const PractitionerRowParent = styled.View`
    padding:30px;
`;

export const PractitonerRowHeader = styled(WorkoutTextHeader)`
    margin-bottom:5px;
`;

export const PractionerRowTool = styled.TouchableOpacity`
    height:35px;
    width:200px;
    background:#3366cc;
    display:flex;
    justify-content:center;
    align-items:center;
    border-radius:50px;
    margin-top:15px;
`

export const ButtonText = styled.Text`
    font-size:16px;
    color:white
`;

export default PractitionerRow;
